import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin: 10px;
`;

export const HeadingWrapper = styled.div`
    display: flex;
    flex: 0 0 40%;
    max-width: 40%;
    justify-content: flex-start;
    align-items: center;
    font-size: 0.9rem;
`;

export const DateInputOuterWrapper = styled.div`
    display: flex;
    flex: 0 0 60%;
    max-width: 60%;
    justify-content: right;
    justify-content: flex-end;
`;

export const DateWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
`;

export interface IInputProps {
    isNotValid?: boolean;
}

export const DateInputWrapper = styled.div<IInputProps>`
    display: flex;
    justify-content: right;
    font-size: 0.8rem;

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
`;
